(function() {
  "use strict";

  $(".open-filtros").on("click", function(e) {
    e.preventDefault();
    openFiltros();
  });

  $(".close-filtros").on("click", function(e) {
    e.preventDefault();
    closeFiltros();
  });

  function openFiltros() {
    $(".gotop").hide();
    $("body").css("overflow", "hidden");
    $(".filtros").addClass("open");
  }

  function closeFiltros() {
    $(".gotop").show();
    $("body").css("overflow", "auto");
    $(".filtros").removeClass("open");
  }

  $("#order").on("change", function() {
    formataFiltros();
  });
  $(".busca-small #form-busca").on("submit", function(e) {
    e.preventDefault();
    formataFiltros();
  });
  $("#form-filtros").on("submit", function(e) {
    e.preventDefault();
    formataFiltros();
  });

  function formataFiltros() {
    var dados = $("#form-busca, #form-filtros, #form-ordernar").serialize();
    window.location = url_base + "anuncios?" + dados;
  }

  // Range preço aluguel
  if ($(".filtro-preco-aluguel-range").length) {
    const campoPrecoRange = $(".filtro-preco-aluguel-range");
    const campoMinPreco = $("#filtro_preco_aluguel_min");
    const campoMaxPreco = $("#filtro_preco_aluguel_max");
    let min = Number(campoPrecoRange.attr("min"));
    const max = Number(campoPrecoRange.attr("max"));
    const values = campoPrecoRange.data("value").split(",");
    let valueMin = values[0];
    let valueMax = values[1];
    campoPrecoRange.slider({
      range: true,
      step: 10,
      min: min,
      max: max,
      values: [valueMin, valueMax],
      slide: function(event, ui) {
        //console.log(ui.values[0], ui.values[1]);
        valueMin = "R$ " + formataMoeda(ui.values[0]);
        valueMax = "R$ " + formataMoeda(ui.values[1]);
        campoMinPreco.val(valueMin);
        campoMaxPreco.val(valueMax);
      }
    });
  }

  // Range preço venda
  if ($(".filtro-preco-venda-range").length) {
    const campoPrecoRange = $(".filtro-preco-venda-range");
    const campoMinPreco = $("#filtro_preco_venda_min");
    const campoMaxPreco = $("#filtro_preco_venda_max");
    let min = Number(campoPrecoRange.attr("min"));
    const max = Number(campoPrecoRange.attr("max"));
    const values = campoPrecoRange.data("value").split(",");
    let valueMin = values[0];
    let valueMax = values[1];
    campoPrecoRange.slider({
      range: true,
      step: 10,
      min: min,
      max: max,
      values: [valueMin, valueMax],
      slide: function(event, ui) {
        //console.log(ui.values[0], ui.values[1]);
        valueMin = "R$ " + formataMoeda(ui.values[0]);
        valueMax = "R$ " + formataMoeda(ui.values[1]);
        campoMinPreco.val(valueMin);
        campoMaxPreco.val(valueMax);
      }
    });
  }
})();
